module.exports = __webpack_public_path__ + "img/crea-tu-perfil-en-Relink-lg.25ac9d7.webp";